import styled from 'styled-components'
import { Paper } from '@material-ui/core'

export const Card = styled(Paper).withConfig<{ color: string }>({
	shouldForwardProp: prop => !['bordered'].includes(prop)
})`
	height: 100%;
	width: 100%;
	padding: 40px;
	border-radius: 10px;
	background-color: ${props => props.color};
	border: 2px solid transparent;

	&:hover {
		border-color: ${props => props.theme.primary.main};
	}
	transition: all 0.3s ease-in-out;
`
